import { Badge } from "@imi/ui/components/Badge/Badge.js";
import { waterCharacteristicsRepository } from "@src/core/engine/technicalParameters/waterCharacteristics/waterCharacteristicsRepository";
import { WaterPhaseValue } from "@src/core/engine/technicalParameters/waterCharacteristics/WaterPhase";
import { useStore } from "@tanstack/react-form";
import { useTranslation } from "react-i18next";
import { useWaterCharacteristicsForm } from "../hooks/useWaterCharacteristicsForm";

type WaterPhaseProps = {
  form: ReturnType<typeof useWaterCharacteristicsForm>["form"];
};

export function WaterPhase({ form }: WaterPhaseProps) {
  const { t } = useTranslation("settings", {
    keyPrefix: "technicalPreferences.waterCharacteristics",
  });
  const waterInformation = useStore(form.store, (state) =>
    waterCharacteristicsRepository.getWaterInformation(
      state.values.mode === "predefined" ? state.values : undefined,
    ),
  );

  return (
    <div>
      {t("waterPhase.label")}:{" "}
      {waterInformation?.data?.waterPhase === WaterPhaseValue.liquid ? (
        <Badge>{t("waterPhase.options.liquid")}</Badge>
      ) : waterInformation?.data?.waterPhase === WaterPhaseValue.ice ? (
        <Badge>{t("waterPhase.options.ice")}</Badge>
      ) : (
        <Badge>{t("waterPhase.options.unknown")}</Badge>
      )}
    </div>
  );
}
